import React from 'react';
import { Alert } from '@mui/material';
import { Funeral } from '../types';
import { DECEASED_PRIMARY_WARNING, primaryContactIsDeceased } from './deceasedPrimary';

/**
 * Shown on a case whose main contact is the person who died (T-210). Family
 * emails and texts to them are skipped until staff choose a family contact.
 */
export function DeceasedPrimaryStrip({ record }: { record?: Partial<Funeral> | null }) {
  if (!primaryContactIsDeceased(record as any)) return null;
  return (
    <Alert severity="warning" sx={{ mx: 2, my: 1 }}>
      {DECEASED_PRIMARY_WARNING}. Emails and texts to them are not sent until the main contact is
      changed.
    </Alert>
  );
}
